import { ClipLoader } from "react-spinners";
import { Text } from "../../../../modules/Dashboard";
import TickIcon from "../../../../components/icons/TickIcon";
import { motion } from "framer-motion";

const Spinner = ({ done }) => {

    return (
        <motion.div
            initial={{ x: 200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            className={`rounded-md px-2 py-1 flex items-center gap-2 max-w-max ${done ? "bg-[#335049]" : "bg-[#5F4239]"
                }`}
        >
            {done ? (
                <TickIcon size={14} color="#00C795" />
            ) : (
                <ClipLoader color={"#FF794D"} size={15} />
            )}
            <Text
                tid={done ? "done" : "processing"}
                className={done ? "text-success" : "text-warn"}
            />
        </motion.div>
    );
};

export default Spinner;
